
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('user', {
      users: 'allUsers',
      adminConsoleUsers: 'adminConsoleUsers'
    })
  },

  methods: {
    /**
    * Dispatch the action in user module in vuex to fetch users data
    * If the variable `users` is empty
    */
    async fetchAllUsers () {
      if (!this.users.length) {
        await this.$store.dispatch('user/fetchAllUsers')
      }
    },

    // Fetch all the admin users.
    async fetchAdminConsoleUsers () {
      if (!this.adminConsoleUsers.length) {
        await this.$store.dispatch('user/fetchAdminConsoleUsers')
      }
    }
  }
}
